module.exports = __webpack_public_path__ + "d5de3430384c82d4e84bf44480a275ae.svg";